import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1714.57143,1645.71429 L1714.57143,1920 L206,1920 L206,1645.71429 L1714.57143,1645.71429 Z M480.285714,0 L480.285714,822.857143 C480.285714,1050.10286 664.468571,1234.28571 891.714286,1234.28571 L891.714286,1234.28571 L1028.85714,1234.28571 C1256.10286,1234.28571 1440.28571,1050.10286 1440.28571,822.857143 L1440.28571,822.857143 L1440.28571,0 L1714.57143,0 L1714.57143,822.857143 C1714.57143,1201.64571 1407.50857,1508.57143 1028.85714,1508.57143 L1028.85714,1508.57143 L891.714286,1508.57143 C513.062857,1508.57143 206,1201.64571 206,822.857143 L206,822.857143 L206,0 L480.285714,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconUnderlineSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconUnderlineSolid, _Component);

  var _super = _createSuper(IconUnderlineSolid);

  function IconUnderlineSolid() {
    _classCallCheck(this, IconUnderlineSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconUnderlineSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconUnderline",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconUnderlineSolid.displayName = "IconUnderlineSolid";
  return IconUnderlineSolid;
}(Component);

IconUnderlineSolid.glyphName = 'underline';
IconUnderlineSolid.variant = 'Solid';
IconUnderlineSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconUnderlineSolid;
export { IconUnderlineSolid };